// Created by Weverton Couto
// on 23/10/2025
// for Techmatic Solutions
// using Odoo 17.0

import React, { useState, useEffect } from 'react';
import { getTodasClinicas } from '../../data/api/adminApi';

const HeaderDashboard = ({ onFiltrosChange, dataInicial, idClinicaInicial, periodoInicial }) => {
    const [data, setData] = useState(dataInicial || new Date().toISOString().split('T')[0]);
    const [idClinica, setIdClinica] = useState(idClinicaInicial || '');
    const [periodo, setPeriodo] = useState(periodoInicial || 'dia');
    const [clinicas, setClinicas] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        carregarClinicas();
    }, []);

    useEffect(() => {
        aplicarFiltros();
    }, [data, idClinica, periodo]);

    const carregarClinicas = async () => {
        try {
            const todasClinicas = await getTodasClinicas();
            setClinicas(todasClinicas || []);
        } catch (error) {
            console.error('Error loading clinics:', error);
        }
    };

    const aplicarFiltros = () => {
        const dataObj = new Date(data);
        const ano = dataObj.getFullYear();
        const mes = dataObj.getMonth();
        
        if (onFiltrosChange) {
            onFiltrosChange({
                data: dataObj,
                ano,
                mes,
                idClinica: idClinica || null,
                periodo: periodo
            });
        }
    };

    const handlePeriodoChange = (novoPeriodo) => {
        setPeriodo(novoPeriodo);
    };

    return (
        <div className="dashboard-header-section">
            <h1 className="dashboard-title">Dashboard de Envio de Mensagens</h1>
            <p className="dashboard-subtitle">Resumo operacional e analítico</p>
            
            <div className="dashboard-filters">
                <div className="filter-group">
                    <label className="filter-label">Data</label>
                    <input
                        type="date"
                        className="filter-input"
                        value={data}
                        onChange={(e) => setData(e.target.value)}
                    />
                </div>
                
                <div className="filter-group">
                    <label className="filter-label">Clínica</label>
                    <select
                        className="filter-input"
                        value={idClinica}
                        onChange={(e) => setIdClinica(e.target.value)}
                    >
                        <option value="">Todas as clínicas</option>
                        {clinicas.map(clinica => (
                            <option key={clinica.idGsDoctor} value={clinica.idGsDoctor}>
                                {clinica.nome || clinica.idGsDoctor}
                            </option>
                        ))}
                    </select>
                </div>

                <div className="period-buttons">
                    <button
                        className={`period-btn ${periodo === 'dia' ? 'active' : ''}`}
                        onClick={() => handlePeriodoChange('dia')}
                    >
                        Hoje
                    </button>
                    <button
                        className={`period-btn ${periodo === 'semana' ? 'active' : ''}`}
                        onClick={() => handlePeriodoChange('semana')}
                    >
                        Semana
                    </button>
                    <button
                        className={`period-btn ${periodo === 'mes' ? 'active' : ''}`}
                        onClick={() => handlePeriodoChange('mes')}
                    >
                        Mês
                    </button>
                    <button
                        className={`period-btn ${periodo === '12meses' ? 'active' : ''}`}
                        onClick={() => handlePeriodoChange('12meses')}
                    >
                        12 Meses
                    </button>
                </div>
            </div>
        </div>
    );
};

export default HeaderDashboard;

